import React, { useEffect, useRef, useState } from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  XIcon,
  TwitterShareButton,
  FacebookMessengerShareButton,
  EmailShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookMessengerIcon,
  LinkedinIcon,
  TelegramIcon,
  WhatsappIcon,
} from 'react-share';

import { Tooltip, TooltipTrigger, TooltipContent } from '../Tooltip/Tooltip';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { MdShare } from 'react-icons/md';

async function getUrFromService(): Promise {
  // The real implementation would make a network call here.
  await new Promise((resolve) => setTimeout(resolve, 1000));
  return 'https://via.placeholder.com/150';
}

export const ShareButton = (props) => {
  const { deeplink, top, right } = props;
  const rightValue = right === undefined ? 12 : right;

  const shareButton = useRef(null);
  const [url, setUrl] = useState('none'); // Unfortunately, we have to have a dummy string here, or FacebookShareButton will blow up.
  // Provide an onClick handler that asyncronously fetches the url and sets it in the state.
  const onClick = async () => {
    // Be sure to check for the "none" state, so we don't trigger an infinite loop.
    if (url === 'none') {
      const newUrl = await getUrFromService();
      setUrl(newUrl);
    }
  };
  // Whenever "url" changes and we re-render, we manually fire the click event on the button, and then re-set the url.
  useEffect(() => {
    if (url !== 'none') {
      shareButton.current?.click();
      setUrl('none');
    }
  }, [url, shareButton]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenuShare = Boolean(anchorEl);

  const handleClickMenuShare = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenuShare = () => {
    setAnchorEl(null);
  };

  const shareArray = [
    { name: 'Facebook', label: 'Facebook' },
    // { name: 'FacebookMessenger', label: 'Messenger' },
    { name: 'Linkedin', label: 'LinkedIn' },
    { name: 'Twitter', label: 'X' },
    // { name: 'Telegram', label: 'Telegram' },
    { name: 'Whatsapp', label: 'WhatsApp' },
    { name: 'Email', label: 'e-mail' },
  ];

  const MapButton: any = {
    Facebook: FacebookShareButton,
    FacebookMessenger: FacebookMessengerShareButton,
    Linkedin: LinkedinShareButton,
    Twitter: TwitterShareButton,
    Telegram: TelegramShareButton,
    Whatsapp: WhatsappShareButton,
    Email: EmailShareButton,
  };

  const MapIcon: any = {
    Facebook: FacebookIcon,
    FacebookMessenger: FacebookMessengerIcon,
    Linkedin: LinkedinIcon,
    Twitter: XIcon,
    Telegram: TelegramIcon,
    Whatsapp: WhatsappIcon,
    Email: EmailIcon,
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={openMenuShare ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openMenuShare ? 'true' : undefined}
        onClick={handleClickMenuShare}
        style={{
          fontSize: '24px',
          position: 'absolute',
          top: top + 'px',
          right: rightValue + 'px',
        }}
      >
        <MdShare />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenuShare}
        onClose={handleCloseMenuShare}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {shareArray.map((d: any, i: number) => {
          let ButtonName = MapButton[d.name];
          let IconName = MapIcon[d.name];
          return (
            <MenuItem onClick={handleCloseMenuShare}>
              <Tooltip>
                <TooltipTrigger>
                  <ButtonName
                    //   ref={shareButton}
                    //   // Disable calling the dialog if we don't have a url yet.
                    //   openShareDialogOnClick={url !== 'none'}
                    //   url={url}
                    //   onClick={onClick}

                    url={deeplink}
                    appId=""
                    // url="https://github.com/"
                  >
                    <IconName
                      borderRadius={100}
                      style={{ width: '32px', height: '32px' }}
                    />
                  </ButtonName>
                </TooltipTrigger>
                <TooltipContent className="Tooltip" style={{ zIndex: 2000 }}>
                  Klik om de deze pagina te delen{' '}
                  {d.name === 'Email' ? 'via' : 'op'} {d.label}
                </TooltipContent>
              </Tooltip>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
